import React, { useEffect, useState, useRef, useCallback } from 'react';
import { isEllipsisActive, ID_FOR_DETECT_CELL_OVERFLOW, SET_FILTER_HOVER_CLASSNAME } from '@/components/AgGrid/helpers';

// TODO: NOT USED FOR NOW - migrate to native ag-grid tooltipShowMode: 'whenTruncated'
const CustomTooltip = ({ valueFormatted, value, colDef }) => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef(null);

  const detectCellOverflow = useCallback(() => {
    try {
      const classesArray = ['.ag-row-hover ', '.ag-column-hover'];

      if (colDef?.cellRendererParams?.needContainerForDetectOverflow) {
        classesArray.push(`#${ID_FOR_DETECT_CELL_OVERFLOW}`);
      }

      if (colDef?.colId === 'ag-Grid-AutoColumn') {
        classesArray.push('.ag-group-value');
      }

      const rowCell = document.querySelector(classesArray.join(' '));
      const filterCell = document.querySelector(`.${SET_FILTER_HOVER_CLASSNAME}`);
      const cell = rowCell || filterCell;

      setIsVisible(Boolean(cell) && isEllipsisActive(cell));
    } catch (error) {
      console.warn('Error detecting cell overflow:', error);
      setIsVisible(false);
    }
  }, [colDef?.cellRendererParams?.needContainerForDetectOverflow, colDef?.colId]);

  // Debounced detection to avoid excessive DOM queries
  const debouncedDetection = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(detectCellOverflow, 16);
  }, [detectCellOverflow]);

  useEffect(() => {
    debouncedDetection();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [debouncedDetection]);

  const displayValue = valueFormatted || value;

  if (!displayValue) {
    return null;
  }

  return (
    <div
      className="ag-tooltip-custom--content"
      style={{
        display: isVisible ? 'flex' : 'none',
      }}
      role="tooltip"
      aria-hidden={!isVisible}
    >
      {displayValue}
    </div>
  );
};

export default CustomTooltip;
